import { removeUrlQueryString, showAlert } from "../../config/utils";
import * as actionTypes from "./constants";
import * as Service from "./services";
import { ERROR_COPY } from "../../config/errorMessages";

const getMenuItems = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MENU_ITEMS_REQUEST });
            const res = await Service.getMenuItems(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_MENU_ITEMS_SUCCESS, response: regionData });
                } else {
                    dispatch({ type: actionTypes.GET_MENU_ITEMS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_MENU_ITEMS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MENU_ITEMS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getSideMenuItems = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_PROJECT_MENU_ITEMS_REQUEST });
            const res = await Service.getSideMenuItems(params.entity, params.params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_PROJECT_MENU_ITEMS_SUCCESS, response: regionData, key: params.response });
                } else {
                    dispatch({ type: actionTypes.GET_PROJECT_MENU_ITEMS_FAILURE, error: regionData });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_PROJECT_MENU_ITEMS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_PROJECT_MENU_ITEMS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const searchMenuItems = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SEARCH_MENU_ITEMS_REQUEST, query: params?.search });
            const res = await Service.searchMenuItems(params);
            if (res && res.status === 200) {
                const menuSearchData = res?.data;
                if (menuSearchData) {
                    dispatch({ type: actionTypes.SEARCH_MENU_ITEMS_SUCCESS, response: menuSearchData, query: params?.search });
                } else {
                    dispatch({ type: actionTypes.SEARCH_MENU_ITEMS_FAILURE, error: menuSearchData, query: params?.search });
                }
            } else {
                dispatch({
                    type: actionTypes.SEARCH_MENU_ITEMS_FAILURE,
                    error: res.response && res.response.data,
                    query: params?.search
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SEARCH_MENU_ITEMS_FAILURE,
                error: e.response && e.response.data,
                query: params?.search
            });
        }
    };
};

export const setFormDirty = value => {
    return dispatch => {
        try {
            dispatch({
                type: actionTypes.SET_FORM_DIRTY_SUCCESS,
                response: value
            });
        } catch (e) {
            dispatch({
                type: actionTypes.SET_FORM_DIRTY_FAILURE,
                error: false
            });
        }
    };
};

export const setPendingAction = action => ({
    type: actionTypes.SET_PENDING_ACTION,
    payload: action
});

export const setPendingCancelAction = callback => ({
    type: actionTypes.SET_PENDING_CANCEL_ACTION,
    payload: callback
});

export const triggerUnsavedChangesPrompt = value => ({
    type: actionTypes.SHOW_UNSAVED_PROMPT,
    payload: value
});

export const triggerFcaNoticePrompt = show => ({
    type: actionTypes.TRIGGER_FCA_NOTICE_PROMPT,
    payload: show
});

const getLinkEmail = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MENU_LINK_EMAIL_REQUEST });
            const res = await Service.getLinkEmail(params);
            if (res && res.status === 200) {
                const regionData = res.data;
                const { s3_url, message, status } = regionData;
                if (regionData.status) {
                    const baseUrl = removeUrlQueryString(s3_url);
                    const res = await Service.getPresignedUrl(baseUrl);
                    if (res && res.status === 200) {
                        const regionData = res.data;
                        const { signed_url } = regionData;
                        const link = document.createElement("a");
                        link.href = signed_url;
                        link.download = signed_url;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                    dispatch({
                        type: actionTypes.GET_MENU_LINK_EMAIL_SUCCESS,
                        response: { message_status: "File Exported Successfully", message: message, status, s3_url }
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_MENU_LINK_EMAIL_SUCCESS,
                        response: { message_status: "File Exported Successfully", message: message, status }
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_MENU_LINK_EMAIL_FAILURE,
                    error: res.response && res.response.data,
                    message: ERROR_COPY.GENERIC
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MENU_LINK_EMAIL_FAILURE,
                error: e.response && e.response.data,
                message: ERROR_COPY.GENERIC
            });
        }
    };
};

export const downloadPresignedUrlFile = async (publicUrl, contentDisposition = "", fileName = "") => {
    if (!publicUrl) return showAlert("Oops. URL not found!");

    try {
        const baseUrl = removeUrlQueryString(publicUrl);
        const res = await Service.getPresignedUrl(baseUrl, contentDisposition, fileName);
        if (res?.status === 200) {
            const { signed_url } = res.data;
            const link = document.createElement("a");
            link.href = signed_url;
            link.download = signed_url;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            showAlert(ERROR_COPY.GENERIC);
        }
    } catch (e) {
        showAlert(ERROR_COPY.GENERIC);
    }
};

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const downloadBulkPresignedUrlFiles = async files => {
    if (!files?.length) {
        return showAlert("No files selected for download!");
    }

    try {
        const urls = files.map(file => ({
            url: removeUrlQueryString(file.url),
            fileName: file.fileName,
            content_disposition: true
        }));

        const res = await Service.getBulkPresignedUrls(urls);
        if (res?.status !== 200) {
            return showAlert(ERROR_COPY.GENERIC);
        }

        const { signed_urls } = res.data;
        if (!signed_urls?.length) return;

        for (let i = 0; i < signed_urls.length; i++) {
            const link = document.createElement("a");
            link.href = signed_urls[i];
            link.download = signed_urls[i];
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            await sleep(2500);
        }
    } catch (e) {
        showAlert(ERROR_COPY.GENERIC);
    }
};

export const getPresignedUrl = async publicUrl => {
    if (!publicUrl) return "";
    try {
        const baseUrl = removeUrlQueryString(publicUrl);
        const res = await Service.getPresignedUrl(baseUrl);
        if (res && res.status === 200) {
            const regionData = res.data;
            const { signed_url } = regionData;
            return signed_url;
        } else {
            return "";
        }
    } catch (e) {
        return "";
    }
};

/**
 * Saves the table configuration.
 *
 * @param {Object} config - The configuration object.
 * @param {string} config.user_id - The user ID (required).
 * @param {string} [config.project_id] - The project ID (optional).
 * @param {string} [config.client_id] - The client ID (optional).
 * @param {String} config.table_type - The table type (required).
 * @param {Object} config.table_settings - The table settings object (required).
 * @returns {void} This function returns nothing.
 * @throws {Error} Throws an error if neither client_id nor project_id is provided.
 */
export const saveTableConfig = async config => {
    try {
        const res = await Service.saveTableConfig(config);
        if (res && (res.status === 200 || res.status === 201)) {
        } else {
            // showAlert("Failed to save table config!");
        }
    } catch (e) {
        // showAlert("Failed to save table config!");
    }
};
/**
 * retrieve the table configuration.
 *
 * @param {string} config.user_id - The user ID (required).
 * @param {string} [config.project_id] - The project ID (optional).
 * @param {string} [config.client_id] - The client ID (optional).
 * @param {String} config.table_type - The table type (required).
 * @returns {void} This function returns nothing.
 * @throws {Error} Throws an error if neither client_id nor project_id is provided.
 */
export const getTableConfig = async params => {
    try {
        const res = await Service.getTableConfig(params);
        if (res && res.status === 200) {
            return res.data;
        } else {
            return null;
        }
    } catch (e) {
        // showAlert("Failed to retrieve table config!");
        return null;
    }
};
export const changeCurrency = currency => ({
    type: actionTypes.CHANGE_CURRENCY,
    payload: currency
});

const actions = {
    getMenuItems,
    getSideMenuItems,
    searchMenuItems,
    setFormDirty,
    getLinkEmail,
    saveTableConfig,
    setPendingAction,
    setPendingCancelAction,
    triggerUnsavedChangesPrompt,
    triggerFcaNoticePrompt,
    downloadBulkPresignedUrlFiles
};

export default actions;
